<template>
    <div>
        <FamilyRegister v-if="showCreateImgFormFamily" @hideCreateFormFamily="hideCreateFormFamily">
        </FamilyRegister>
        <div class="me-5"><button class="btn btn-danger float-end" @click="showCreateFormFamily">Crear nuevo <br>grupo de
                formas</button>
        </div>
        <div v-show="showNoneFilter">
            <div class="card text-bg-light w-50 my-4 mx-auto" style="max-width: 18rem;">
                <div class="card-header"><svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor"
                        class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                        <path
                            d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z" />
                        <path
                            d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
                    </svg></div>
                <div class="card-body">
                    <h5 class="card-title danger">Ups!</h5>
                    <p class="card-text">Utilice alguno de los filtros disponibles e intente de nuevo.</p>
                </div>
            </div>
        </div>
        <div class="container table-responsive mx-auto" v-show="showImgFormFamilies">
            <table class="table">
                <tbody>
                    <tr>
                        <th>Línea</th>
                        <th>Nombre del grupo de formas</th>
                        <!-- <th>Materias primas asociadas</th> -->
                        <th>Imagen representativa del grupo</th>
                    </tr>
                    <tr v-for="imgFormFamily in allImgFormFamilies" :key="imgFormFamily.id">
                        <td>{{ imgFormFamily.type }}</td>
                        <td>{{ imgFormFamily.name }}</td>
                        <!-- <td>{{ imgFormFamily.rawMaterials }}</td> -->
                        <td> <img :src="serverUrl + 'images/forms/' + imgFormFamily.referenceImage
                            " class="ml-2" style="max-width: 250px; max-height: 250px;"></td>
                        <td><button class="btn btn-danger ms-2"
                                @click.prevent="editImgFormFamily(imgFormFamily.id)">Editar</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import FamilyRegister from "@/components/Admin/Families/RegisterImgFormFamilyAdminComponent.vue";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        sendFamiliesByFilter: Object,
    },
    watch: {
        sendFamiliesByFilter(newVal) {
            if (newVal !== null) {
                this.allImgFormFamilies = this.sendFamiliesByFilter;
                // console.log(this.allImgFormFamilies.length);
                if (this.allImgFormFamilies.length === 0) {
                    this.showNoneFilter = false;
                    this.showImgFormFamilies = false;
                } else {
                    this.showNoneFilter = false;
                    this.showImgFormFamilies = true;
                }
            }
        },
    },
    components: {
        FamilyRegister,
    },
    data() {
        return {
            serverUrl: RUTA_SERVIDOR,
            allImgFormFamilies: [],
            showCreateImgFormFamily: false,
            showNoneFilter: true,
            showImgFormFamilies: false,
        };
    },
    methods: {
        showCreateFormFamily() {
            this.showNoneFilter = false;
            this.showCreateImgFormFamily = true;
        },
        hideCreateFormFamily(data) {
            this.showCreateImgFormFamily = data;
        },
        editImgFormFamily(imgFormFamily) {
            //console.log(imgFormFamily);
            this.$emit("sendImgFormFamilyId", { imgFormId: imgFormFamily, showEdit: true });
        },
    },
}
</script>